import axios from "axios";
import { domainUrl } from "../constants/apiconstans/domanUrl";
import {
  getUserData,
  getBearerToken,
  getRefreshToken,
  setTokensAndExpiry,
  isTokenExpire,
  getTokenExpiry,
} from "../utils/user";
import { helperFunction } from "../helpers";
let isRefreshing = false;
let refreshSubscribers = [];

const axiosInstance = axios.create({
  baseURL: domainUrl,
  headers: { "Content-Type": "application/json" },
});
const axiosRefresh = axios.create({
  baseURL: domainUrl,
  headers: { "Content-Type": "application/json" },
});

const subscribeTokenRefresh = (callback) => {
  refreshSubscribers.push(callback);
};
const onRefreshed = (newToken) => {
  refreshSubscribers.forEach((callback) => callback(newToken));
  refreshSubscribers = [];
};

const isTokenExpired = () => {
  let tokenExpiry = getTokenExpiry();
  if (!tokenExpiry) {
    // alert("token expired")
    localStorage.clear();
    window.location.href = "/";
  }
  let result = isTokenExpire(tokenExpiry);
  if (result) {
    // alert('token expired')
    return true;
  } else {
    return false;
  }
};
const refreshAccessToken = async () => {
  try {
    const token = await getBearerToken();
    const refreshToken = getRefreshToken();
    if (!refreshToken || !token)
      throw new Error("Missing required data (token or refresh token)");
    // const { data } = await axiosRefresh.post('/refreshToken', {refreshToken, "AccessToken": token})
    const { data } = await axiosRefresh.post("/refreshToken", { refreshToken });
    if (data?.success && data?.user) {
      let result = data?.user;
      setTokensAndExpiry(
        result?.token,
        result?.refreshToken,
        result?.tokenExpire,
      );
      onRefreshed(result?.token);
      return result?.token;
    } else throw "error";
  } catch (error) {
    // alert("error while refreshing token")
    localStorage.clear();
    window.location.href = "/";
    return Promise.reject(error);
  } finally {
    isRefreshing = false;
  }
};

// ✅ Request Interceptor: Check token before making API requests
axiosInstance.interceptors.request.use(async (config) => {
  const token = await getBearerToken();
  if (isTokenExpired()) {
    if (!isRefreshing) {
      isRefreshing = true;
      refreshAccessToken();
    }
    return new Promise((resolve) => {
      subscribeTokenRefresh((newToken) => {
        config.headers["Authorization"] = `Bearer ${newToken}`;
        resolve(config);
      });
    });
  }

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// ✅ Response Interceptor: Handle 401 errors & refresh token
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (!isRefreshing) {
        isRefreshing = true;
        refreshAccessToken();
      }

      return new Promise((resolve) => {
        subscribeTokenRefresh((newToken) => {
          originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
          resolve(axiosInstance(originalRequest)); // Retry request with new token
        });
      });
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
